
<div class="card p-2 bg-white text-dark shadow-sm small w-100 border-0 rounded-3 task-card" @click="open_task_modal(task, bucket)">
    <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center mb-3">
        <input type="radio" class="form-check-input d-none" />
        <div class="fs-xsm mt-1 mx-2">{{ task.name }}</div>

    </div>
   <i class="bi bi-three-dots dropdown-toggle"
   id="dropdownMenu2"
   data-bs-toggle="dropdown"
   aria-expanded="false"
   @click.stop>
</i>

      <ul
        ref="assignmenu"
        class="dropdown-menu dropdown-menu-start rounded-3 p-0 text-xs border-0 shadow-sm"
        aria-labelledby="dropdownMenu2"
        @click.stop
      >
        <li>
          <button class="dropdown-item" type="button" @click.stop="toggleAssignDropdown">
            <i class="bi bi-person-plus"></i> Assign
          </button>
        </li>
        <li><button class="dropdown-item" type="button" @click.stop="delete_task(task.id)"><i class="bi bi-trash3"></i> Delete</button></li>
      </ul>
      <div
        ref="assignDropdown"
        class="dropdown-menu px-1 shadow border-0 assignment-dropdown"
        :class="{ show: showAssignDropdown }"
        data-bs-auto-close="outside"
        @click.stop
      >
        <input
          type="text"
          class="form-control form-control-sm text-xxs rounded-3 border-0 border-bottom mb-2"
          placeholder="Type a name or email address"
          v-model="searchQuery"
        />
        <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Suggestions</div>

        <div
          v-for="member in members"
          :key="member.id"
          class="d-flex align-items-center px-2 py-1 dropdown-item"
          @click="assignUser(member.id,task.id)"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center me-2 py-2 text-xxs text-white bg-primary w-20 h-20"
          >
            {{ getInitials(member.full_name) }}
          </div>
          <span class="text-dark small fs-xsm">{{ member.full_name }}</span>
        </div>
      </div>

    </div>
    <div class="d-flex mb-2">
      <span class="badge bg-primary text-white me-1" v-if="task.priority_name">{{ task.priority_name }}</span>
      <span class="badge bg-primary text-white me-1" v-if="task.status_name">{{ task.status_name }}</span>

    </div>
<div class="d-flex justify-content-between fs-xsm">
    <div
      v-if="task.due_date"
      class="small p-1"
      :class="{
        'bg-danger text-white rounded-3 shadow-sm': new Date(task.due_date).setHours(0,0,0,0) < new Date().setHours(0,0,0,0),
        'text-muted': new Date(task.due_date).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)
      }"
    >
      <i class="bi bi-calendar3 me-1 fw-500"></i>
      Due: <span class="fw-bold">{{ task.due_date_formatted }}</span>
    </div>
    <div class="d-flex">
    <div v-for ="user in task.assignees"
      :key="user.id"
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary align-items-center text-white py-2 ms-1 w-20 h-20"
    >
      {{ getInitials(user.full_name) }}
    </div>
    </div>
</div>

  </div>

<!-- Modal -->
